import React, { useEffect, useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { getEnums } from "../../Redux/Actions/enumsActions";
import { viewCategoryList } from "../../Redux/Actions/categoryActions";
import { viewUnitList } from "../../Redux/Actions/unitsActions";
import { editAmenities, viewAmenity } from "../../Redux/Actions/amenitiesResaleActions";
import AddImage from "../../Global Functions/addImage";
import { useNavigate, useParams, Link } from "react-router-dom";
import toast from "react-hot-toast";
import "./addAmenities.css";

const UploadIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
    <polyline points="17 8 12 3 7 8" />
    <line x1="12" y1="3" x2="12" y2="15" />
  </svg>
);

const TrashIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
    <path d="M10 11v6M14 11v6" />
    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
  </svg>
);

const EditAmenities = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [amenityData, setAmenityData] = useState({
    id: id,
    amenityName: "",
    position: Math.floor(Math.random() * 1000) + 1,
    category: "",
    unit: "",
    amenitiesFor: "",
    image: "",
  });

  useEffect(() => {
    const payloadData = { page: 1, limit: 1000 };
    dispatch(viewCategoryList(payloadData));
    dispatch(viewUnitList(payloadData));
    dispatch(getEnums());
    dispatch(viewAmenity(id));
  }, [dispatch, id]);

  const { amenity } = useSelector((state) => state.amenitiesResale || {});

  useEffect(() => {
    if (amenity?.data) {
      setAmenityData((prev) => ({
        ...prev,
        amenityName: amenity.data.name || "",
        position: amenity.data.position || prev.position,
        category: amenity.data.category || "",
        unit: amenity.data.unit || "",
        amenitiesFor: amenity.data.amenities_for || "",
        image: amenity.data.image || "",
      }));
    }
  }, [amenity]);

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const imageUrl = await AddImage(file);
    if (imageUrl) {
      setAmenityData((prev) => ({ ...prev, image: imageUrl }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!amenityData.amenityName.trim()) return toast.error("Amenity title is required");

    setLoading(true);
    try {
      let filteredData = { ...amenityData };
      Object.keys(filteredData).forEach((key) => {
        if (filteredData[key] === "" || filteredData[key] === null) {
          delete filteredData[key];
        }
      });
      const response = await dispatch(editAmenities(filteredData));
      if (response?.statusCode === 200) {
        toast.success("Amenity updated successfully!");
        navigate("/amenities_resale");
      } else {
        toast.error(response?.message || "Failed to update amenity");
      }
    } catch (error) {
      toast.error(error?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <MainLayout>
      <div className="ab-wrapper">
        <div className="ab-header">
          <div className="ab-header-left">
            <div className="ab-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
              </svg>
            </div>
            <div>
              <h1 className="ab-title">Edit Amenity</h1>
              <p className="ab-subtitle">Update the details for this amenity</p>
            </div>
          </div>
          <Link to="/amenities_resale" className="ab-view-btn">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
            View Amenity List
          </Link>
        </div>

        <form className="ab-form" onSubmit={handleSubmit}>
          <div className="ab-section ab-section--visible">
            <div className="ab-section-header">
              <span className="ab-section-badge">01</span>
              <h2 className="ab-section-title">Amenity Details</h2>
            </div>
            <div className="ab-grid ab-grid-2">
              <div className="ab-field">
                <label className="ab-label">Amenity Title <span className="ab-req">*</span></label>
                <input
                  className="ab-input"
                  type="text"
                  name="amenityName"
                  value={amenityData.amenityName}
                  onChange={(e) => setAmenityData((prev) => ({ ...prev, amenityName: e.target.value }))}
                  placeholder="e.g. Swimming Pool"
                  disabled={loading}
                />
              </div>

              <div className="ab-field">
                <label className="ab-label">Amenity Icon <span className="ab-optional">(Optional)</span></label>
                {amenityData.image ? (
                  <div className="aa-image-preview">
                    <img src={amenityData.image} alt="Amenity icon" className="aa-preview-img" />
                    <div className="aa-preview-info">
                      <span className="aa-preview-label">Icon uploaded</span>
                      <button
                        type="button"
                        className="aa-remove-btn"
                        onClick={() => setAmenityData((prev) => ({ ...prev, image: "" }))}
                        disabled={loading}
                      >
                        <TrashIcon />
                        Remove
                      </button>
                    </div>
                  </div>
                ) : (
                  <label className="aa-upload-zone" htmlFor="edit-amenity-image">
                    <input
                      id="edit-amenity-image"
                      type="file"
                      name="image"
                      accept="image/*"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                      disabled={loading}
                    />
                    <div className="aa-upload-icon"><UploadIcon /></div>
                    <span className="aa-upload-text">Click to upload icon</span>
                    <span className="aa-upload-hint">PNG, JPG, SVG up to 2MB</span>
                  </label>
                )}
              </div>
            </div>
          </div>

          <div className="ab-footer">
            <div className="ab-footer-nav">
              <button type="submit" className="ab-btn ab-btn--submit" disabled={loading}>
                {loading ? (
                  "Saving..."
                ) : (
                  <>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                    Save Changes
                  </>
                )}
              </button>
            </div>
            <Link to="/amenities_resale" className="ab-btn ab-btn--cancel">
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default EditAmenities;